// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"899643fc","187":"f98d6cc9","188":"6bfdad41","264":"fefe5c71","453":"1f960028","564":"02e98c97","708":"76e0c252","946":"3aad7260"}[chunkId] + ".chunk.js";
};